export const formatRepeatedFailuresGroupedTableValue = (value) => {
  if (value === null || value === undefined || value === '') return 'N/A';
  return String(value);
};

export const getRepeatedFailuresGroupedTableFlows = (item) =>
  Array.isArray(item.flows) ? item.flows : [];

export const getRepeatedFailuresGroupedTableAttributes = (item) =>
  Array.isArray(item.attributes) ? item.attributes : [];

export const getRepeatedFailuresGroupedTableFailingAttributes = (flow) => {
  if (Array.isArray(flow.failing_attributes)) return flow.failing_attributes;
  if (Array.isArray(flow.failing_attributee)) return flow.failing_attributee;
  if (flow.failing_attributes) return [flow.failing_attributes];
  if (flow.failing_attributee) return [flow.failing_attributee];
  return [];
};

export const getRepeatedFailuresGroupedTableGroupLabel = (group) =>
  group.event || group.attribute || 'Unknown';
